import CompanySignup from '@/components/CompanySignup'
import ForgotPassword from '@/components/ForgotPassword'
import PageNotFound from '@/components/PageNotFound'
import ResetPassword from '@/components/ResetPassword'
import Router from 'vue-router'
import SignupLandingPage from '@/components/SignupLandingPage'
import UserSignup from '@/components/UserSignup'
import Vue from 'vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: SignupLandingPage
    },
    {
      path: '/company.html',
      component: CompanySignup
    },
    {
      path: '/forgot-password.html',
      component: ForgotPassword
    },
    {
      path: '/reset-password.html',
      component: ResetPassword
    },
    {
      path: '/user.html',
      component: UserSignup
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})
